export const CPF_DIGITS_LENGTH = 11;

export const extractCpfDigits = (value) =>
  String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, CPF_DIGITS_LENGTH);

export const formatCpf = (value) => {
  const digits = extractCpfDigits(value);

  if (digits.length !== CPF_DIGITS_LENGTH) {
    return String(value ?? '');
  }

  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};
